import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back_icon",
  "use": "icon-back_icon-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-back_icon\">\r\n  <title>fanhui</title>\r\n  <path d=\"M12.446 9.776v-7.109l-12.446 12.443 12.446 12.448v-7.291c8.888 0 15.112 2.844 19.554 9.067-1.776-8.89-7.11-17.776-19.554-19.557z\" fill=\"#7f8493\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/back_icon.svg
// module id = SlSf
// module chunks = 14